import { useMemo } from 'react'
import { resolvePluginIdForMimeType, type AssetCreation, type PluginId } from '@common/plugin-host'
import { assetPluginRegistry } from './registry'

export type AssetPluginResolution = {
  uiPluginId?: PluginId
}

export type CreatableAssetKind = {
  pluginId: PluginId
  creates: AssetCreation
  mimeTypes: readonly string[]
}

const plugins = Object.values(assetPluginRegistry)

export const useAssetPlugin = (mimeType: string | undefined): AssetPluginResolution | undefined =>
  useMemo(() => {
    if (!mimeType) return undefined
    return { uiPluginId: resolvePluginIdForMimeType(plugins, mimeType) }
  }, [mimeType])

// The kinds a new asset can be authored as, rather than uploaded — one per creation descriptor a
// plugin's manifest declares. Static per registry (no mime type to resolve against), so it needs
// no hook.
export const creatableAssetKinds = (): CreatableAssetKind[] =>
  Object.entries(assetPluginRegistry).flatMap(([pluginId, plugin]) =>
    (plugin.creates ?? []).map((creates) => ({
      pluginId: pluginId as PluginId,
      creates,
      mimeTypes: plugin.mimeTypes ?? [],
    }))
  )

export default useAssetPlugin
